import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';
import { Typography } from '@mui/material';
import Container from 'components/Container';
import Archive2022 from '../ClassAssembly2023/Archive2022';
import ClassAssemblySidebar2026 from '../ClassAssemblySidebar2026';

const ClassAssembly9D2026 = () => {
  const theme = useTheme();
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = (index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  };

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  const [config, setConfig] = useState({ base_image_url_2026: '' });
  useEffect(() => {
    fetch('/config.json')
      .then(response => response.json())
      .then(data => setConfig(data))
      .catch(error => console.error('Error fetching config:', error));
  }, []);

  const p1 = `${config.base_image_url_2026}/home/events-activities/class-assembly/9D/1.webp`;
  const p2 = `${config.base_image_url_2026}/home/events-activities/class-assembly/9D/2.webp`;
  const p3 = `${config.base_image_url_2026}/home/events-activities/class-assembly/9D/3.webp`;
  const p4 = `${config.base_image_url_2026}/home/events-activities/class-assembly/9D/4.webp`;
  const p5 = `${config.base_image_url_2026}/home/events-activities/class-assembly/9D/5.webp`;
  const p6 = `${config.base_image_url_2026}/home/events-activities/class-assembly/9D/6.webp`;
  const p7 = `${config.base_image_url_2026}/home/events-activities/class-assembly/9D/7.webp`;
  const p8 = `${config.base_image_url_2026}/home/events-activities/class-assembly/9D/8.webp`;
  const p9 = `${config.base_image_url_2026}/home/events-activities/class-assembly/9D/9.webp`;
 
  const photos = [
    { src: p1, source: p1, rows: 1, cols: 1 },
    { src: p2, source: p2, rows: 1, cols: 1 },
    { src: p3, source: p3, rows: 1, cols: 1 },
    { src: p4, source: p4, rows: 1, cols: 1 },
    { src: p5, source: p5, rows: 1, cols: 1 },
    { src: p6, source: p6, rows: 1, cols: 1 },
    { src: p7, source: p7, rows: 1, cols: 1 },
    { src: p8, source: p8, rows: 1, cols: 1 },
    { src: p9, source: p9, rows: 1, cols: 1 },
  ];

  return (
    <Main>
      <Container>
        <Grid container spacing={4}>
          <Grid item xs={12} md={8}>
            <Box>
              <Box>
                <Typography variant="h4" align="center">
                Topic: ‘Rooted in Sanskrit, Powered by NEP-Importance of Sanskrit’
                </Typography>
                <Typography fontSize="x-small">
                  <br />
                  <br />
                  Class: 9D    Date: 14 & 15 JULY 2026
                </Typography>

                <br />
               <Typography variant={'subtitle1'} align={'justify'}>
     Students of Class 9D presented an inspiring assembly on the theme<strong> "Rooted in Sanskrit, Powered by NEP – The Importance of Sanskrit." </strong>
     The assembly commenced with a meaningful Sanskrit shloka that highlighted the significance of ‘Sanskrit’ as the foundation 
     of India's rich cultural and intellectual heritage, while emphasising its relevance in the National Education Policy (NEP) 2020. 
                <br></br>
              The highlight of the assembly was an engaging skit that beautifully illustrated how the timeless wisdom of Sanskrit continues to inspire values, scientific thinking and holistic learning in the modern world.
               The students showcased how NEP encourages the study of Sanskrit as a means to preserve India's knowledge systems and promote multilingualism. 
               Adding vibrancy to the programme, the students presented a melodious Sanskrit song that celebrated the beauty, richness and timeless relevance of the language.
               This was followed by a graceful dance performance that artistically portrayed India's cultural heritage.
<br></br>
</Typography>
              </Box>

            <Typography
                variant="h6"
                 color="primary"
                 align="center"
                 fontWeight="normal">
                <br />
               “Sanskrit is not just a language. It is the key to our past, a tool for our present and a bridge to our future.”
                 <br />
            </Typography>

              <Box>
                <ImageList
                  variant="quilted"
                  cols={2}
                  rowHeight={isMd ? 200 : 100}
                  gap={isMd ? 16 : 4}
                >
                  {photos.map((item, i) => (
                    <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                      <LazyLoadImage
                        height={'100%'}
                        width={'100%'}
                        src={item.src}
                        alt="Class Assembly 10A 2026"
                        effect="blur"
                        onClick={() => openLightbox(i)}
                        style={{
                          objectFit: 'cover',
                          filter:
                            theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                          cursor: 'pointer',
                          borderRadius: 8,
                        }}
                      />
                    </ImageListItem>
                  ))}
                </ImageList>
              </Box>

              {viewerIsOpen && (
                <Lightbox
                  mainSrc={photos[currentImage].src}
                  nextSrc={photos[(currentImage + 1) % photos.length].src}
                  prevSrc={photos[(currentImage + photos.length - 1) % photos.length].src}
                  onCloseRequest={() => closeLightbox()}
                  onMovePrevRequest={() =>
                    setCurrentImage((currentImage + photos.length - 1) % photos.length)
                  }
                  onMoveNextRequest={() =>
                    setCurrentImage((currentImage + 1) % photos.length)
                  }
                  reactModalStyle={{ overlay: { zIndex: 1500 } }}
                />
              )}
            </Box>
          </Grid>

          <Grid item xs={12} md={4}>
            <Box marginBottom={4}>
              <ClassAssemblySidebar2026 />
            </Box>
            <Box marginBottom={4}>
              <Archive2022 />
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Main>
  );
};

export default ClassAssembly9D2026;
